import type { ReactNode } from 'react';

interface AuthCardProps {
    children: ReactNode;
    className?: string;
}

/**
 * AuthCard - Specialized card for authentication forms
 * Optimized for login/register with proper width constraints
 */
export function AuthCard({ children, className = '' }: AuthCardProps) {
    return (
        <div
            className={`
        w-full
        min-w-[320px]
        max-w-[600px]
        mx-auto
        bg-surface
        border border-border
        rounded-asymmetric-lg
        p-6 sm:p-8 md:p-10 lg:p-12
        shadow-glow
        animate-slide-up
        ${className}
      `.trim().replace(/\s+/g, ' ')}
        >
            {children}
        </div>
    );
}
